<template>
  <div class="auth">
    <div class="columns">
      <div class="column is-full-height is-two-fifths form-half">
        <article class="login-wrapper" v-loading="pending">
          <h4 class="is-size-4 has-padding-bottom">Register for Duplikit</h4>
          <div class="has-margin-top">
            <el-form
              :model="signupForm"
              :rules="rules"
              ref="signupForm"
              label-position="top"
              label-width="100px"
              @submit.prevent.native="onSubmit('signupForm')"
            >
              <el-form-item prop="email">
                <el-input placeholder="Email" type="email" v-model="signupForm.email"></el-input>
              </el-form-item>
              <el-form-item prop="password" class="mt-2">
                <el-input
                  placeholder="Please input password"
                  show-password
                  v-model="signupForm.password"
                ></el-input>
              </el-form-item>
              <el-button native-type="submit" type="primary">Register</el-button>
              <el-button type="text" @click="goToLogin()">Existing Account?</el-button>
            </el-form>
            <div class="is-size-7 mt-6">
              <router-link :to="{ name: 'privacy' }" class="has-text-grey-dark">Privacy Policy</router-link>
              {{ ' ' }} |
              <router-link :to="{ name: 'terms' }" class="has-text-grey-dark">Terms of Use</router-link>
            </div>
          </div>
        </article>
      </div>

      <div class="column is-full-height is-hidden-mobile is-three-fifths landing-welcome">
        <article class="has-text-centered">
          <a href="https://duplikit.co">
            <img
              style="max-width:40%; height:auto; display:block; margin:0 auto;"
              src="@/assets/brand/logo-white.png"
            />
          </a>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { REGISTER } from '@/store/action-types';

const rules = {
  email: [{ required: true, type: 'email', message: 'Email is required', trigger: 'blur' }],
  password: [
    { required: true, type: 'string' },
    { min: 8, message: 'Password must be at least 8 characters.', trigger: 'blur' },
  ],
};

export default {
  name: 'Register',
  data() {
    return {
      signupForm: {
        email: '',
        password: '',
      },
      rules,
      pending: false,
      error: '',
    };
  },
  methods: {
    async onSubmit(signupForm) {
      this.pending = true;
      try {
        this.$refs[signupForm].validate(async (valid) => {
          if (valid) {
            await this.$store.dispatch(REGISTER, this.signupForm);
            if (this.$store.state.authStatus === 'success') {
              this.$router.push('/content');
            } else {
              this.pending = false;
            }
          } else {
            console.log('Error signing up.');
            this.pending = false;
          }
          return valid;
        });
      } catch (error) {
        this.error = error;
      }
    },

    goToLogin() {
      this.$router.push('/login');
    },
  },
};
</script>

<style lang="scss" scoped>
article {
  position: relative;
  top: 50%;
  text-align: center;
  transform: translate(0, -50%);
  padding: 1rem;
}

.landing-welcome {
  background-color: #865efc;
  color: white;
  height: 103vh;
}

.login-wrapper {
  padding: 5em;
}

.el-form-item {
  margin-bottom: 0.2em;
}

.login-wrapper button.el-button.el-button--primary {
  margin-top: 2em;
  min-width: 140px;
}

.router-view-container {
  padding-top: 0 !important;
}

@media screen and (max-width: 768px) {
  .login-wrapper {
    -webkit-transform: translate(0, -50%);
    transform: inherit;
  }
}
</style>
